<template>
    <v-navigation-drawer
            class="setting-drawer"
            temporary
            right
            v-model="drawer"
            hide-overlay
            fixed
            width="370"
    >
        <v-toolbar color="secondary" dark flat>
            <v-toolbar-title class="pl-2">{{$t(title)}}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn @click="execute" color="accent" :loading="executeNow">
                Aplicar
            </v-btn>
            <v-divider vertical inset class="mx-3"></v-divider>
            <v-btn icon @click="close" medium outline>
                <v-icon>close</v-icon>
            </v-btn>
        </v-toolbar>
        <vue-perfect-scrollbar class="drawer-scroll" :settings="scrollSettings" :style="{'max-height': contentHeight}">
            <component :is="currentComponent" :execute="executeNow" :key="renderKey" @close="close"
                       :reloadKey="reloadKey"></component>
        </vue-perfect-scrollbar>
    </v-navigation-drawer>
</template>

<script>
   import VuePerfectScrollbar from 'vue-perfect-scrollbar';

   export default {
      name: "AppRightDrawer",
      components: {VuePerfectScrollbar},

      data() {
         return {
            title: 'appMsg.filter',
            drawer: false,
            executeNow: false,
            currentComponent: null,
            scrollSettings: {
               maxScrollbarLength: 160
            },
            contentHeight: '500px',
            renderKey: 0,
            reloadKey: 0
         }
      },

      watch: {
         currentComponent() {
            this.renderKey = +new Date();
            this.executeNow = false;
         }
      },

      methods: {
         close() {
            this.executeNow = false;
            window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED');
         },
         execute() {
            this.executeNow = true;
            // setTimeout(() => this.close(), 150);
         }
      },

      created() {
         window.getApp.$on('APP_RIGHT_DRAWER_TOGGLED', (aComponent) => {
            if (aComponent) {
               this.currentComponent = aComponent;
               if (!this.drawer)
                  this.reloadKey = +new Date();
            }
            this.executeNow = false;
            this.drawer = (!this.drawer);
         });
      },

      mounted() {
         this.contentHeight = `${this.$el.clientHeight - 64}px`;

      }

   }
</script>

<style scoped>
    .drawer-scroll {
        overflow-x: hidden;
        overflow-y: auto;
    }

    .theme--light.v-navigation-drawer {
         background-color: #f5f5f5;
    }
</style>



// WEBPACK FOOTER //
// node_modules/@consigmais-team/vue-common/layout/components/AppRightDrawer.vue